import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ls from 'local-storage'
import { Map } from 'immutable'
import ReduxToastr from 'react-redux-toastr'

import config from '../../config'

import { LOCALE_PREFIX } from './constants'
import { sessionKey } from '../../services/authorization/constants'

import LoginForm from './components/LoginForm'
import Loader from './components/Loader'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Login extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        login: PropTypes.func.isRequired,
    }

    componentDidMount() {
        const { login } = this.props
        const lsSessionId = ls(sessionKey)

        if (!config.iframeSolution && lsSessionId) {
            login({
                sessionId: lsSessionId,
                autologin: true,
            })
        }
    }

    onLoginHandler = (values = Map()) => {
        const { login } = this.props

        login({
            username: values.get('username', ''),
            password: values.get('password', ''),
        })
    }

    renderLoginPage = () => (
        <div className={'login-page'}>
            <div className={'form-wrap'}>
                <div className={'white-logo'} />
                <div className={'white-shadow'} />
                <div className={'white-logo-with-gradient'} />
                <div className={'links'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.company`}
                        values={{
                            a: (chunks) => (
                                <a href="https://www.dnb.com/cs-cz/" target="_blank" rel="noopener noreferrer">
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                    <span className={'link-separator'} />
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.support`}
                        values={{
                            a: (chunks) => <a href="mailto:podpora.cz@dnb.com">{chunks}</a>,
                        }}
                    />
                </div>
                <div className={'form-block'}>
                    <LoginForm onSubmit={this.onLoginHandler} />
                </div>
            </div>
        </div>
    )

    render() {
        const { isLoading } = this.props

        return (
            <div className={'login'}>
                {isLoading ? <Loader /> : this.renderLoginPage()}
                <ReduxToastr {...config.toastr.init} />
            </div>
        )
    }
}
